import type {ApiQueryParams} from '@/types/api';

export const siteKeys = {
  all: ['sites'] as const,

  lists: () => [...siteKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams = {}) =>
    [...siteKeys.lists(), filters] as const,

  details: () => [...siteKeys.all, 'detail'] as const,
  detail: (id: string) => [...siteKeys.all, 'detail', id] as const,
};
